<template>
  <!--
          作者 luoyiming
          时间：2020-06-09
          描述：会员-实名制列表管理
      -->
  <div class="user">
    <!---->
    <div class="common-level-rail"></div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="realname" label="姓名"></el-table-column>
          <el-table-column
            prop="idnumber"
            label="身份证号"
            width="200"
          ></el-table-column>
          <el-table-column prop="f_image" label="身份证正面" width="200">
            <template slot-scope="scope">
              <img
                :src="scope.row.fimage.filePath"
                width="60px"
                height="40px"
              />
            </template>
          </el-table-column>
          <el-table-column prop="z_image" label="身份证反面" width="200">
            <template slot-scope="scope">
              <img
                :src="scope.row.zimage.filePath"
                width="60px"
                height="40px"
              />
            </template>
          </el-table-column>
          <el-table-column prop="status" label="是否审核">
            <template slot-scope="scope">
              <div>{{ scope.row.status == 1 ? "是" : "否" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="审核原因"
            width="400"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建日期"
            width="150"
          ></el-table-column>

          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button
                @click="editClick(scope.row)"
                type="primary"
                :disabled="scope.row.status == 1"
                size="small"
                >审核</el-button
              >

              <el-button
                @click="deleteClick(scope.row)"
                type="danger"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <!-- <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div> -->
    </div>

    <!--添加-->
    <Add
      v-if="open_add"
      :open_add="open_add"
      @closeDialog="closeDialogFunc($event, 'add')"
    ></Add>

    <!--编辑-->
    <Edit
      v-if="open_edit"
      :open_edit="open_edit"
      :form="userModel"
      @closeDialog="closeDialogFunc($event, 'edit')"
    ></Edit>
  </div>
</template>

<script>
import UserApi from "@/api/user.js";
import Edit from "./Edit.vue";
import Add from "./Add.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
    Edit,
    Add
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: "",
        region: ""
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*换行*/
    keepTextStyle(val) {
      let str = val.replace(/(\\r\\n)/g, "<br/>");
      return str;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.pageIndex = self.curPage;
      Params.status = "";

      Params.pageSize = self.pageSize;
      UserApi.realnamelist(Params, true)
        .then(data => {
          self.loading = false;
          console.log("===========", data);
          self.tableData = data.data.list.data;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;

          UserApi.deleterealname(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: data.msg,
                  type: "success"
                });
                self.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/part/list.vue